<template>
  <!-- <v-select
    dense
    outlined
    return-object
    item-text="name"
    v-model="duration"
    :items="durationList"
    :label="$t('downtime.downtimeDuration')"
    prepend-inner-icon="$downtimeLog"
  ></v-select> -->
  <div class="mb-4">
    <v-row no-gutters>
      <v-col cols="7">
        <v-select
          dense
          outlined
          hide-details
          v-model="operator"
          :items="operators"
          :label="$t('downtime.downtimeDuration')"
          @change="onFilterChange"
        ></v-select>
      </v-col>
      <v-col cols="5">
        <v-text-field
          dense
          outlined
          type="number"
          min="0"
          v-model="durationMinutes"
          suffix="mins"
          hide-details
          @change="onFilterChange"
          @keyup.enter="onFilterChange"
        ></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {
  mapMutations,
  mapGetters,
} from 'vuex';

const FIELD_NAME = 'downtimeduration';

export default {
  name: 'DurationSelection',
  data() {
    return {
      // durationList: [{
      //   name: this.$t('downtime.allDurations'),
      //   value: 0,
      // }, {
      //   name: this.$t('downtime.mins', { min: 2 }),
      //   value: 120,
      // }, {
      //   name: this.$t('downtime.mins', { min: 30 }),
      //   value: 1800,
      // }],
      operator: 'Greater than',
      operators: ['Greater than', 'Less than'],
      durationMinutes: 2,
    };
  },
  computed: {
    ...mapGetters('webApp', ['filters']),
    isDurationFilterInactive() {
      return !Object
        .keys(this.filters)
        .includes(FIELD_NAME);
    },
    // duration: {
    //   get() {
    //     const durationFilter = this.filters && this.filters[FIELD_NAME];
    //     if (durationFilter) {
    //       const value = this.durationList.find((s) => s.value === durationFilter.value);
    //       if (value) {
    //         return value;
    //       }
    //     }
    //     return this.durationList[1];
    //   },
    //   set(durationVal) {
    //     this.setDurationFilter(durationVal);
    //   },
    // },
  },
  created() {
    if (this.isDurationFilterInactive) {
      // this.setDurationFilter(this.durationList[1]);
      this.onFilterChange();
    } else {
      const existing = this.filters[FIELD_NAME];
      if (existing && existing.value) {
        this.durationMinutes = existing.value / 60;
        this.operator = existing.operation === 'lte' ? 'Less than' : 'Greater than';
      }
    }
  },
  methods: {
    ...mapMutations('webApp', ['setFilter']),
    // setDurationFilter(duration) {
    onFilterChange() {
      const seconds = parseFloat(this.durationMinutes || 0) * 60;
      const operation = this.operator === 'Less than' ? 'lte' : 'gte';
      this.setFilter({
        field: FIELD_NAME,
        value: {
          // value: duration.value,
          // operation: 'gte',
          value: seconds,
          operation,
        },
      });
    },
  },
};
</script>
